// extracted by mini-css-extract-plugin
export default {"Root":"stop-watch_Root__r6QKh"};